import type { FaireProductEntity } from "../../entity_types/product";

export const atc_updated_fs_rec_7: FaireProductEntity = {
  token: "atc_updated_fs_rec_7",
  type: "product",
  name: "Outdoor Cloud LED Lamps (Set of 2)",
  brandName: "Faire Source",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/579a7fb90a070d3ec5782f9379a55973ab58550f1ec3545205475b8e2895884e.webp",
  priceDollars: 125,
  msrpDollars: 160,
  description: "Recommended product for ATC flow.",
  tags: ["home", "design", "recommendations"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
